var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        { staticClass: "pt-4" },
        [
          _c("v-text-field", {
            attrs: {
              color: "accent",
              filled: "",
              "single-line": "",
              rules: _vm.characterInputRules.name,
              label: _vm.dataBrowserResource.name,
              disabled: _vm.disableNameInput,
            },
            on: { blur: _vm.onNameChange },
            model: {
              value: _vm.editName,
              callback: function ($$v) {
                _vm.editName = $$v
              },
              expression: "editName",
            },
          }),
          _c(
            "div",
            { staticClass: "d-flex flex-row align-center mb-4" },
            [
              _c("p", { staticClass: "ma-0 mr-4" }, [
                _vm._v(_vm._s(_vm.dataBrowserResource.share)),
              ]),
              _c("v-switch", {
                attrs: { color: "accent", disabled: _vm.disableSharing },
                on: { change: _vm.onShareChange },
                model: {
                  value: _vm.editSharing,
                  callback: function ($$v) {
                    _vm.editSharing = $$v
                  },
                  expression: "editSharing",
                },
              }),
            ],
            1
          ),
          _c("v-textarea", {
            attrs: {
              color: "accent",
              filled: "",
              rows: "2",
              "no-resize": "",
              rules: _vm.characterInputRules.notes,
              label: _vm.dataBrowserResource.notes,
              disabled: _vm.disableNotesInput,
            },
            on: { blur: _vm.onNotesChange },
            model: {
              value: _vm.editNotes,
              callback: function ($$v) {
                _vm.editNotes = $$v
              },
              expression: "editNotes",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { outlined: "", color: "accent" },
              nativeOn: {
                click: function ($event) {
                  return _vm.onAction(-1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.commonResource.close))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }